'use client'

import { ReactNode } from 'react'
import { Provider } from 'react-redux'

import { store } from '../../store/store'

interface IConfigReduxContainerProps {
  children: ReactNode
}

const ConfigReduxContainer: React.FC<IConfigReduxContainerProps> = ({
  children,
}) => {
  return <Provider store={store}>{children}</Provider>
}

export default ConfigReduxContainer
